// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addProductWithAdditionalParameters } from "@conklin/App/Services/CartService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addProductWithResult } from "@insite/client-framework/Services/CartService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";

export const XngSendDataToApi: any = async (props: any) => {
    // XNG-Changes: additionalQueryStringParameters
    const parameter = props.apiParameter;
    const result = parameter.additionalQueryStringParameters
        ? await addProductWithAdditionalParameters(parameter)
        : await addProductWithResult(parameter);

    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

replaceInChain(chain, SendDataToApi, XngSendDataToApi);
